import { formatUnits } from 'viem';
import { useAccount, useBalance, useReadContract } from 'wagmi';
import { ERC20_ABI } from './abis';
import { getTokenAddress } from './contracts';
import { TARGET_CHAIN } from './config';
import { useTokenDecimals } from './useTokenDecimals';

// this wagmi/viem version's useBalance only fetches the native currency (no
// `token`/`formatted` fields), so ERC20 balances are read directly via balanceOf
export function useTokenBalance(symbol: string) {
  const { address, chainId } = useAccount();
  const readChainId = chainId ?? TARGET_CHAIN.id;
  const isNative = symbol === 'BNB';
  const tokenAddress = getTokenAddress(symbol, readChainId);
  const decimals = useTokenDecimals(symbol);

  const { data: nativeBalance } = useBalance({
    address,
    chainId: readChainId,
    query: { enabled: Boolean(address && isNative) },
  });

  const { data: tokenBalance } = useReadContract({
    address: tokenAddress,
    abi: ERC20_ABI,
    functionName: 'balanceOf',
    args: address ? [address] : undefined,
    chainId: readChainId,
    query: { enabled: Boolean(address && tokenAddress && !isNative) },
  });

  const raw = isNative ? nativeBalance?.value : tokenBalance;
  const formatted = raw !== undefined ? formatUnits(raw, decimals) : undefined;

  return { raw, formatted };
}
